/**
 * Removes all non-alphanumeric or space characters from a string, except for #.
 *
 * @param toStrip The string to strip
 * @returns The stripped string
 */
export function stripSearchString(toStrip: string): string {
    return toStrip.replace(new RegExp('[^a-zA-Z0-9# ]', 'g'), '');
}
